import { HttpService, Repository, RepositoryBase, Tags, Weaver } from '@skylab-shared/core';
import { OrderKindModel } from '@skylab-shared/dataModel';
import { pickBy } from '@skylab-shared/utils';
import { OrderKindBO } from './order-kind.bo';


@Repository({
	boType: OrderKindBO,
	apiController: {
		base: 'Orders/kinds/:name',
		tags: [Tags.Api]
	}
})
export class OrderKindRepositoryBase extends RepositoryBase<OrderKindBO, OrderKindModel> {
	public constructor(
		private readonly weaver: Weaver,
		$http: HttpService,
	) {
		super($http);
	}

	protected createBO(): OrderKindBO {
		return new OrderKindBO(this.weaver);
	}

	protected async preparePlainObjectAsync(model: OrderKindModel): Promise<any> {
		return {
			version: model.version,
			name: model.name,
			defaultDocumentToIssue: model.defaultDocumentToIssue,
			defaultVatRateId: model.defaultVatRateId
		};
	}

	protected async fromPlainObjectAsync(item: any): Promise<OrderKindModel> {
		return new OrderKindModel(pickBy<OrderKindModel>({
			version: item.version,
			name: item.name,
			defaultDocumentToIssue: item.defaultDocumentToIssue,
			defaultVatRateId: item.defaultVatRateId
		}, val => val !== void 0));
	}
}
